<div class="row">
  <div class="col-sm-12">
    <!--    <app-breadcrumb-->
    <!--      [title]="'Files'"-->
    <!--      [layout]="layout"-->
    <!--      [breadcrumbItems]="breadcrumbItems"-->
    <!--      (layoutSelected)="onLayoutSelected($event)"-->
    <!--    ></app-breadcrumb>-->
  </div>
</div>
<!--[addButtonRoute]="'/dash/files/create'"-->
<div class="row">
  <div class="col-12" *ngIf="isWithinDialog()">
    <div class="flex-fill float-end mt-2 me-2">
      <a href="javascript: void(0);" (click)="onCloseClicked()">
        <i class="bx bxs-x-circle text-danger"></i>
      </a>
    </div>
  </div>
  <div class="col-sm-12">
    <div class="card card-body">
      <app-basic-filter
        [addBtnText]="'Upload'"
        (addButtonClick)="onUpsertClick(null)"
        [useParamNavigation]="false"
        (filterClick)="onFilterClick($event)"
      ></app-basic-filter>

      <div class="col-sm-auto mt-3" *ngIf="isAnySelected()">
        <button type="button" class="btn btn-success w-md me-3"
                (click)="useSelectedFiles()">
          <span i18n="@@label.UseSelected">Use Selected</span>
        </button>
        <button type="button" class="btn btn-warning w-md"
                (click)="clearSelection()">
          <span i18n="@@label.ClearSelection">Clear Selection</span>
        </button>
      </div>
    </div>
  </div>

  <util-progress *ngIf="loading" [bar]="true"></util-progress>

  <div class="account-pages my-2" *ngIf="images.content.length===0">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center mb-5">
            <h1 class="display-2 fw-medium"><i class="bx bx-buoy bx-spin text-primary display-3"></i></h1>
            <h4 class="text-primary" *ngIf="loading" i18n="@@msg.Loading">Cooking your data, please wait..</h4>
            <h4 class="text-uppercase" *ngIf="!loading" i18n="@@msg.NoItems">No items</h4>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="assets/apanel/images/error-img.png" alt="" class="img-fluid">
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="images.content.length>0">
    <div class="row" *ngIf="layout === Layout.COLUMN"
         [@dataLoaded]="loading?'loading':'loaded'"
         [@onColumn]="layout==Layout.COLUMN">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <p class="card-title-desc" i18n="@@msg.MyFiles">Files that I've created</p>
            <div class="table table-responsive">
              <table class="table table-editable table-nowrap align-middle table-edits table-hover table-bordered">
                <thead>
                <tr>
                  <th i18n="@@label.Id">Id</th>
                  <th *ngIf="config.showUserFilter" i18n="@@label.CreatedBy">Created By</th>
                  <th i18n="@@label.Title">Title</th>
                  <th i18n="@@label.CreatedAt">Created At</th>
                  <th i18n="@@label.LastUpdate">Last Updated</th>
                  <th i18n="@@label.Update">Update</th>
                  <th *ngIf="config.showDeleteButton" i18n="@@label.Delete">Delete</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let item of images.content">
                  <td>{{ item.id }}</td>
                  <td *ngIf="config.showUserFilter">{{ item.created_by }}</td>
                  <td>
                    <a href="javascript: void(0);"
                       (click)="onUpsertClick(item.id)">
                      {{ item.image_url }}
                    </a>
                  </td>
                  <td><small>{{ item.created_at | readableDate }}</small></td>
                  <td><small>{{ item.updated_at | readableDate }}</small></td>

                  <td style="width: 100px">
                    <a (click)="onUpsertClick(item.id)"
                       class="btn btn-outline-warning btn-sm edit" title="Edit">
                      <i class="fas fa-pencil-alt"></i>
                    </a>
                  </td>

                  <td *ngIf="config.showDeleteButton" style="width: 100px">
                    <!--                <app-delete [requestUrl]="config.delEndpoint +'/'+item.id"-->
                    <!--                            (deleteItemEvent)="onDeleted($event)"-->
                    <!--                ></app-delete>-->
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div> <!-- end col -->
    </div>

    <div *ngIf="layout === Layout.GRID" class="row"
         [@dataLoaded]="loading?'loading':'loaded'"
         [@onGrid]="layout==Layout.GRID"
         [ngClass]="isWithinDialog()?'ms-2 me-2':''">
      <div class="col-xxl-2 col-xl-3 col-sm-4 col-6" *ngFor="let item of images?.content">
        <div class="card text-center" [ngClass]="isSelected(item)?'border-3 border-success':''">
          <div class="image-container" (click)="toggleFileSelection(item)">
            <a>
              <img *ngIf="item.image_url" class="card-img-top img-fluid center-cropped-image" src="{{item.image_url}}"
                   alt="Card image cap">
            </a>
            <!--          <img class="rounded-circle avatar-sm" src="{{q.post.images[0]}}" alt="">-->
          </div>
          <div class="card-body" (click)="toggleFileSelection(item)" *ngIf="isAdmin()">
            <h6 class="font-size-10 text-info">
              <span i18n="@@label.UploadedBy">Uploaded By</span> {{ item.created_by }}
            </h6>
          </div>
          <div class="card-footer bg-transparent border-top">
            <div class="contact-links d-flex font-size-20">
              <div class="flex-fill">
                <a href="javascript: void(0);" (click)="TextUtility.copyToClipboard(item.image_url)">
                  <i class="bx bx-copy text-success"></i>
                </a>
              </div>
              <div class="flex-fill" *ngIf="config.showDeleteButton">
                <app-delete [requestUrl]="config.imgDelEndpoint +'/'+item.id+'/delete'"
                            (deleteItemEvent)="onDeleted($event)" [look]="'bx'"></app-delete>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-pagination *ngIf="!isWithinDialog()" [page]="legacyPage()"></app-pagination>

  <div class="row ms-2 me-2" *ngIf="isWithinDialog()">
    <div class="col-lg-12 grid-margin stretch-card mt-3">
      <div class="col-sm-auto float-start" *ngIf="isAnySelected()">
        <button type="button" class="btn btn-success w-md me-3"
                (click)="useSelectedFiles()">
          <span i18n="@@label.UseSelected">Use Selected</span>
        </button>
        <button type="button" class="btn btn-warning w-md"
                (click)="clearSelection()">
          <span i18n="@@label.ClearSelection">Clear Selection</span>
        </button>
      </div>

      <div class=" float-end">
        <nav aria-label="Page navigation example">
          <ul class="pagination">
            <li class="page-item">
              <a href="javascript: void(0);"
                 class="page-link {{images.page===0?'disabled': ''}}"
                 (click)="onPreviousClick()" i18n="@@label.Previous">Previous</a>
            </li>

            <li class="page-item">
              <a href="javascript: void(0);"
                 (click)="onNextClick()" i18n="@@label.Next">Next</a></li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

</div>
